<template>
  <div class="container d-flex justify-content-center align-items-center mt-4">
    <div class="logo-container">
      <img
        class="img-fluid img-size-control"
        src="@/assets/ft-logo-login.png"
        width="300"
        alt="Falcon - Soluções Inteligentes"
      />
    </div>
    <div class="login">
      <div v-if="submitSuccess">
        <div class="row mb-3">
          <h1 class="h1-bem-vindo poppins-light">
            E-MAIL
            <span class="poppins-semibold">ENVIADO</span>
          </h1>
          <h2 class="h2-slogan poppins-light">
            {{ mensagem }} O link expira em 30 minutos.
          </h2>
        </div>
        <div class="extand-login-button">
          <span></span>
          <router-link to="/login" class="btn btn-secondary">Voltar ao login</router-link>
        </div>
      </div>

      <form v-else @submit.prevent="submit">
        <div class="row mb-3">
          <h1 class="h1-bem-vindo poppins-light">
            RECUPERAR
            <span class="poppins-semibold">SENHA</span>
          </h1>
          <h2 class="h2-slogan poppins-light">
            Informe o e-mail da sua conta para receber o link de redefinição de senha
          </h2>
        </div>

        <div class="row">
          <div class="form-group">
            <label for="email" class="label-login">Email</label>
            <input
              type="email"
              class="form-control"
              id="email"
              v-model="email"
              required
            />
          </div>
        </div>

        <div class="row">
          <div class="extand-login-button">
            <router-link to="/login" class="link-login">Já lembrei a senha</router-link>
            <button type="submit" class="btn btn-secondary" :disabled="loading">
              {{ loading ? 'Enviando...' : 'Enviar link' }}
            </button>
          </div>
        </div>
      </form>

      <div v-if="error" class="row mt-3">
        <div class="col-md-12">
          <div class="alert alert-danger fade show" role="alert">
            {{ error }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
import axiosApi from "@/axios";
import Footer from "@/components/Footer.vue";

const MENSAGEM_PADRAO = "Email enviado, você receberá instruções para redefinir a senha.";

export default {
  name: "EsqueciSenha",
  components: { Footer },
  data() {
    return {
      email: "",
      loading: false,
      error: "",
      submitSuccess: false,
      mensagem: "",
    };
  },
  methods: {
    async submit() {
      this.error = "";
      this.loading = true;
      try {
        const response = await axiosApi.post("/api/senha/esqueci", {
          email: this.email,
        });
        this.mensagem = response.data?.message || MENSAGEM_PADRAO;
        this.submitSuccess = true;
      } catch (err) {
        this.error = err.response?.data?.message || "Não foi possível enviar o link. Tente novamente.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.link-login {
  color: inherit;
  text-decoration: none;
  font-size: 0.9rem;
}

.link-login:hover {
  text-decoration: underline;
}
</style>
